"use client";

import { SectionBadge } from "./SectionBadge";
import { useI18n } from "@/i18n/context";

export function WhenSection() {
  const { t } = useI18n();

  return (
    <section id="when" className="relative bg-bg-primary py-[88px] px-8">
      <div className="mb-[80px]" data-reveal>
        <SectionBadge>{t.when.badge}</SectionBadge>
      </div>

      <h2 data-reveal className="font-clash font-bold text-[38px] text-text-primary text-center uppercase tracking-[2.66px] leading-normal max-w-[1320px] mx-auto mb-[24px]">
        {t.when.title}
      </h2>

      <div className="font-besley text-[24px] text-text-secondary text-center tracking-[1.68px] leading-normal max-w-[776px] mx-auto space-y-[28px]">
        <p data-reveal>{t.when.beacon}</p>

        <div data-reveal data-reveal-stagger>
          {t.when.befores.map((b, i) => (
            <p key={i}>{b}</p>
          ))}
        </div>

        <p data-reveal className="whitespace-pre-line">{t.when.moving}</p>
        <p data-reveal className="whitespace-pre-line">{t.when.lighthouse}</p>
        <p data-reveal className="whitespace-pre-line">{t.when.better}</p>
      </div>
    </section>
  );
}
